import AppTokens from "./AppTokens";

export default AppTokens;
